import { render, staticRenderFns } from "./edit-forecast.vue?vue&type=template&id=c56c8238&scoped=true"
import script from "./edit-forecast.vue?vue&type=script&lang=js"
export * from "./edit-forecast.vue?vue&type=script&lang=js"
import style0 from "./edit-forecast.vue?vue&type=style&index=0&id=c56c8238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c8238",
  null
  
)

export default component.exports